import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { first } from 'rxjs/operators';
import { RouterConstants } from '../_models/router-constants';
import { TokenStorageService } from '../auth/token-storage.service';
import { GoogleLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';
import { Backend } from '../_models/backend';
import { environment } from '../../environments/environment';
import { sortFn } from '../_shared/helper';
import LoginRequest = Backend.LoginRequest;
import StudentDTOOnNotebook = Backend.StudentDTOOnNotebook;
import ClassIdSlimDTO = Backend.ClassIdSlimDTO;

declare var loginObj: LoginComponent;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginRequest: LoginRequest = { username: '', password: '', oauth: false };

  logoClickCounter = 0;
  minClickNum = 5;
  hasPairedLoginToken = false;

  groups: any[] = [];
  users: any[] = [];

  selectedGroupIconId: number | null | undefined = -1;
  selectedUserIconId = -1;

  currentIconView: 'groupIcons' | 'userIcons' = 'groupIcons';

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService, private tokenStorageService: TokenStorageService,
              private socialAuthService: SocialAuthService, private ngZone: NgZone) {
    loginObj = this;

    // redirect to home if already logged in
    if (this.authService.currentUserValue && this.authService.isStudent()) {
      this.router.navigate(['/'], {replaceUrl: true});
    }

    const pairedLoginToken = this.tokenStorageService.getPairedLoginToken();
    if (pairedLoginToken != null) {
      this.hasPairedLoginToken = true;
      this.authService.setPairingUser(pairedLoginToken); // új tab nyitásakor, ha a localStorage-ban volt paired token, akkor be kell állítani a sessionStorage-ba egy PAIRED_DEVICE role-os usert is
    }
  }

  ngOnInit(): void {
    this.socialAuthService.authState.subscribe((user) => {
      console.log(user);
      this.onSubmitForm(true, { username: user.email, password: user.idToken, oauth: true });
    });

    if (this.hasPairedLoginToken) {
      this.authService.listClassIds().pipe(first()).subscribe(response => {
        this.groups = response.sort(sortFn<ClassIdSlimDTO>('visualId'));
      }, error => {
        this.tokenStorageService.clearPairedLoginToken();
        this.hasPairedLoginToken = false;
      });
    }
  }

  onSubmitForm(valid: boolean | null, loginRequest: LoginRequest): void {
    if (valid) {
      this.authService.login(loginRequest)
        .pipe(first())
        .subscribe({
          next: () => {
            // get return url from route parameters or default to '/'
            const returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
            this.router.navigate([returnUrl], {replaceUrl: true});
          }
        });
    }
  }

  onSubmitIcons(): void {
    console.log(this.selectedGroupIconId);
    console.log(this.selectedUserIconId);
    this.authService.loginInfant(this.selectedUserIconId)
      .pipe(first())
      .subscribe({
        next: user => {
          console.log(user);

          // get return url from route parameters or default to '/'
          const returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
          this.router.navigate([returnUrl], {replaceUrl: true});
        }
      });
  }

  onSelectGroupIcon(group: ClassIdSlimDTO): void {
    this.selectedGroupIconId = group.id;
    console.log(group);

    if (group.id != null) {
      this.authService.listStudentsByClassId(group.id).subscribe(response => {
        this.users = response;
      });
    }
  }

  onSelectUserIcon(user: StudentDTOOnNotebook): void {
    this.selectedUserIconId = user.id;
    console.log(user);
  }

  nextToUserIcons(): void {
    this.currentIconView = 'userIcons';
  }

  backToGroupIcons(): void {
    this.currentIconView = 'groupIcons';
  }

  onLogoClick(): void {
    if (this.logoClickCounter < this.minClickNum) {
      this.logoClickCounter++;
    }
  }

  navigateToRegister(): void {
    this.router.navigate(['/' + RouterConstants.PAIRING], {replaceUrl: true});
  }

  clearPairedLoginToken(): void {
    this.tokenStorageService.clearPairedLoginToken();
    location.reload();
  }

  signInWithGoogle() {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  handleCredentialResponse(response: any) {
    function b64DecodeUnicode(str: string) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    }

    function decodeJwtResponse(credential: string) {
      return JSON.parse(b64DecodeUnicode(credential.split('.')[1]));
    }

    // to decode the credential response.
    const user = decodeJwtResponse(response.credential);

    console.log("ID: " + user.sub);
    console.log('Full Name: ' + user.name);
    console.log('Given Name: ' + user.given_name);
    console.log('Family Name: ' + user.family_name);
    console.log("Image URL: " + user.picture);
    console.log("Email: " + user.email);

    console.log(user);
    this.ngZone.run(() => { this.onSubmitForm(true, { username: user.email, password: response.credential, oauth: true }); });
  }

  signOut(): void {
    this.socialAuthService.signOut();
  }

  refreshToken(): void {
    this.socialAuthService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
  }

  getWebAppClientId(): string {
    return environment.webapp_client_id;
  }

}
